import { Box, Checkbox, Typography } from "@mui/material";

interface ValuesListHeaderProps {
  title: string;
  allChecked: boolean;
  indeterminate: boolean;
  onSelectAll: (checked: boolean) => void;
}

export const ValuesListHeader: React.FC<ValuesListHeaderProps> = ({
  title,
  allChecked,
  indeterminate,
  onSelectAll,
}) => {
  return (
    <Box
      sx={{
        background: "#00838F",
        color: "#fff",
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Checkbox
        checked={allChecked}
        indeterminate={indeterminate}
        onChange={(e) => onSelectAll(e.target.checked)}
        sx={{
          color: "#fff",
          p: 0,
          mr: 1,
          "&.Mui-checked": { color: "#fff" },
          "&.MuiCheckbox-indeterminate": { color: "#fff" },
        }}
      />
      <Typography variant="subtitle1" fontWeight={700}>
        {title}
      </Typography>
    </Box>
  );
};

const ValuesListHeaderComponent = ValuesListHeader;
export default ValuesListHeaderComponent;
